import { useEffect } from 'react'

export default function AppTitle({ append = true, text }) {
  useEffect(() => {
    let prev = document.title

    document.title = append ? `${text} • ${prev}` : text

    return () => {
      document.title = prev
    }
  }, [append, text])

  return null
}
